export default {
  // 基礎通用
  base_common: {
    workbench: '門戶',
    library: '文件庫',
    memo: '備忘錄',
    approval: '審批中心',
    project: '項目協作',
    knowledge: '知識庫',
    knowledgeDoc: '知識文檔',
    email: '郵件管理',
    report: '數據報表',
    attendance: '考勤中心',
    salary: '智能薪酬',
    task: '任務',
    schedule: '日程',
    determine: '確定',
    save: '保存',
    cancel: '取消',
    submit: '提交',
    down: '下載',
    import: '導入',
    export: '導出',
    picture: '圖片',
    video: '視頻',
    audio: '音頻',
    file: '文檔',
    nothing: '無',
    newbuilt: '新建',
    remove: '移除',
    add: '新增',
    adjunction: '添加',
    copy: '復制',
    open: '打開',
    query: '查詢',
    previews: '預覽',
    yes: '是',
    no: '否',
    on: '開啟',
    off: '關閉',
    rename: '重命名',
    comment: '溝通',
    relation: '關聯',
    member: '成員',
    addMember: '添加成員',
    sharedMembers: '共享成員',
    look: '查看',
    set: '設置',
    close: '關閉',
    search: '搜索',
    select: '選擇',
    selectAll: '全選',
    to: '至',
    stopUsing: '停用',
    disable: '禁用',
    enable: '啟用',
    year: '年',
    month: '月',
    week: '周',
    day: '日',
    day2: '天',
    hour: '小時',
    minute: '分鐘',
    ge: '個',
    tiao: '條',
    yuan: '元',
    tips: '提示',
    mustFill: '必填',
    required: '必填項',
    norecoverable: '刪除後不可恢復',
    determineDelete: '你確定要刪除嗎?',
    print: '打印',
    upload: '上傳',
    uploadFiles: '上傳文件',
    size: '大小',
    status: '狀態',
    administrator: '管理員',
    time: '時間',
    createTime: '創建時間',
    create_by: '創建人',
    modify_time: '修改時間',
    start_time: '開始時間',
    end_time: '結束時間',
    modify_by: '修改人',
    operation: '操作',
    approvalTypeAfterReject: '驳回後审批方式',
    spread: '展開',
    retract: '收起',
    man: '男',
    woman: '女',
    person: '人',
    content: '內容',
    visibleRange: '可見範圍',
    networkFailPleaseTryAgain: '網絡異常，請稍候重試',
    SelectDataMinOne: '最少選擇壹條數據',
    uncultivated: '該功能暫未開發',
    roledepemp: '成員、部門、角色',
    custom: '自定義',
    sso: '單點登錄',
    page404: '抱歉，你訪問的頁面不存在',
    local: '本地',
    // 20210715
    taskYdt: '我的待辦',
    tip: {
      deleteTip: '刪除後不可恢復。'
    },
    message: {
      addSuccess: '新增成功',
      editorSuccess: '編輯成功',
      copySuccess: '復制成功',
      moveSuccess: '移動成功',
      success: '保存成功',
      upload: '上傳成功',
      delete: '刪除成功',
      operate: '操作成功',
      send: '發送成功',
      perform: '執行成功',
      playFail: '執行失敗',
      import: '導入成功',
      timeRange: '範圍請選擇開始時間和截止時間',
      refushTip: '數據已更新，請刷新頁面'
    },
    placeholder: {
      all: '全部',
      selected: '選中',
      input: '請輸入',
      select: '請選擇',
      select_must: '請選擇(必填)',
      pwd: '請輸入密碼',
      newpwd: '請輸入新密碼',
      confirmpwd: '確認密碼',
      code: '請輸入驗證碼',
      phone: '請輸入手機號碼',
      keywords: '請輸入關鍵字',
      chooseDate: '選擇日期',
      chooseTime: '選擇時間',
      chooseYM: '選擇年月',
      chooseDatetime: '選擇日期時間',
      ctrlEnter: '評論內容（Ctrl+Enter發送）',
      matrixName: '請輸入矩陣名稱',
      jobPositionName: '請輸入崗位名稱'
    },
    error: {
      empty: '不能為空',
      noAuthority: '沒有權限',
      phone: '手機號碼格式錯誤',
      phone_empty: '手機號碼不能為空',
      name_empty: '名稱不能為空',
      pwd: '密碼格式錯誤',
      pwd_empty: '密碼不能為空',
      pwd_atypism: '兩次密碼輸入不壹致',
      pwd_accordwith: '密碼必須符合要求',
      code: '驗證碼錯誤',
      code_empty: '驗證碼不能為空',
      PwdPopover: '密碼最小長度至少',
      PwdPopover0: '個字符',
      PwdPopover1: '個字符且必須包含字母和數字字符',
      PwdPopover2: '個字符且必須包含字母、數字和特殊字符',
      PwdPopover3: '個字符且必須包含數字和大小寫字母',
      PwdPopover4: '個字符且必須包含數字、大小寫字母和特殊字符',
      fileSize: '單個文件大小不能超過100M',
      fileSize2: '文件大小不得超過200MB',
      fileSize20: '文件大小不得超過20MB',
      formatError: '格式錯誤',
      formatError2: '上傳格式錯誤',
      scaleError: '小數位數錯誤',
      outOfInputRange: '超出輸入範圍',
      enterMin: '輸入最小值',
      enterMax: '輸入最大值',
      visibleRange_empty: '可見範圍不能為空'
    },
    screenInfo: {
      // 篩選信息
      asc: '升序',
      desc: '降序',
      Filled: '已填寫',
      notFilled: '未填寫',
      today: '今天',
      yesterday: '昨天',
      thisWeek: '本周',
      lastWeek: '上周',
      pastSevenDays: '過去七天',
      past30Days: '過去30天',
      thisMonth: '本月',
      lastMonth: '上月',
      thisQuarter: '本季度',
      lastQuarter: '上季度',
      thisYear: '本年',
      lastYear: '上年',
      timeRange: '範圍'
    },
    weeks: {
      Mon: '星期一',
      Tues: '星期二',
      Wed: '星期三',
      Thur: '星期四',
      Fri: '星期五',
      Sat: '星期六',
      Sun: '星期日'
    },
    weeksTwo: {
      Mon: '周一',
      Tues: '周二',
      Wed: '周三',
      Thur: '周四',
      Fri: '周五',
      Sat: '周六',
      Sun: '周日'
    },
    weeksThree: {
      Mon: '一',
      Tues: '二',
      Wed: '三',
      Thur: '四',
      Fri: '五',
      Sat: '六',
      Sun: '日'
    },
    userInfo: {
      name: '姓名',
      gender: '性別',
      department: '部門',
      company: '機構',
      superior: '上級',
      landline: '座機',
      phone: '手機',
      tel: '電話',
      email: '郵箱',
      birthday: '生日',
      emid: '工號',
      enable: '狀態',
      postName: '職務',
      roleName: '角色',
      account: '賬號',
      area: '地區',
      address: '地址',
      material: '資料',
      activated: '已激活',
      notActive: '未激活',
      hobbie: '興趣愛好'
    },
    comments: {
      moreCommon: '條更多評論',
      backTop: '返回頂部',
      expression: '表情',
      send: '發送',
      message_empty: '不能發送空白評論'
    },
    members: {
      selectMember: '選擇成員',
      selected: '已選',
      includingSubordinateDepartment: '包含下級部門',
      member: '成員',
      department: '部門',
      role: '角色',
      dynamicParameters: '動態參數',
      current_login_personnel: '當前成員',
      current_main_department: '當前部門'
    },
    preview: {
      image: '圖片',
      rotate: '左旋轉',
      rotate1: '右旋轉',
      magnif: '放大',
      shrink: '縮小',
      dpwnload: '下載',
      fullScreen: '全屏查看',
      exitfull: '退出全屏'
    },
    // 2020-10-15
    insufficientAuth: '權限不足，請聯系系統管理員',
    gobackBaseModule: '返回基礎模塊',
    action: {
      pause: '暫停',
      archive: '歸檔',
      release: '發布',
      undo: '撤銷',
      transferleader: '轉移負責人',
      share: '共享',
      retreattotheopenseapool: '退回公海池',
      convert: '轉換',
      pickup: '領取',
      allocate: '分配',
      move: '移動',
      batchmodification: '批量修改',
      recovery: '恢復',
      managefolders: '管理文件夾',
      setupadministrator: '設置管理員',
      setpermissions: '設置權限',
      completelydelete: '徹底刪除',
      recoverymemo: '恢復備忘',
      reset: '重置',
      enabledisable: '啟用/禁用',
      accountbinding: '賬戶綁定',
      processapproval: '流程審批',
      modifyapprover: '修改審批人'
    },
    image: {
      fill: '填充',
      adapt: '適應',
      stretch: '拉伸',
      tiled: '平鋪',
      centere: '居中'
    },
    data: '數據'
  }
}
